const caminhoInterno1 = "http://192.168.0.101:3001/api/tgcapmail/";
const caminhoInterno2 = "http://192.168.0.110:3001/api/tgcapmail/";
const caminhoExterno1 = "http://201.73.145.39:3001/api/tgcapmail/"

let caminhoAPI = "";

function retornaCaminhoApi(tipoCaminho)
{
    if (tipoCaminho == 1)
    {
        caminhoAPI = caminhoInterno1
    }
    else if (tipoCaminho == 2)
    {
        caminhoAPI = caminhoInterno2
    }
    else if (tipoCaminho == 3)
    {
        caminhoAPI = caminhoExterno1
    }
    
console.log(caminhoAPI)
    return caminhoAPI;
}

module.exports = retornaCaminhoApi;